const BASE_URL = '';

const handleResponse = async (res) => {
    if (!res.ok) {
        const errorText = await res.text().catch(() => null);
        throw new Error(errorText || 'API Request failed');
    }
    return res.json().catch(() => ({}));
};

const defaultHeaders = (hasJson = true) => {
    const headers = {};
    if (hasJson) headers['Content-Type'] = 'application/json';
    const token = localStorage.getItem('token');
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
};

const request = (path, opts = {}) => fetch(`${BASE_URL}${path}`, opts).then(handleResponse);

export const api = {
    // Generic helpers used by services
    get: (path) => request(path, { method: 'GET', headers: defaultHeaders(false) }),
    post: (path, body) => request(path, { method: 'POST', headers: defaultHeaders(true), body: JSON.stringify(body) }),
    patch: (path, body) => request(path, { method: 'PATCH', headers: defaultHeaders(true), body: JSON.stringify(body) }),
    delete: (path) => request(path, { method: 'DELETE', headers: defaultHeaders(false) }),

    // Specific auth helpers (kept for convenience)
    login: (data) => fetch(`${BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(handleResponse),

    register: (data) => fetch(`${BASE_URL}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(handleResponse),

    // Example admin endpoint kept for compatibility
    getUsers: () => request('/api/users'),

    // inhaler update example (protected)
    updateInhaler: (doses) => request('/api/user/inhaler', {
        method: 'PATCH',
        headers: defaultHeaders(true),
        body: JSON.stringify({ remainingDoses: doses })
    })
};
